import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class AuditTrailsProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(): Promise<AuditTrailDTO[]> {
        const url = this.configurationService.APIURL + '/api/audittrails';
        return await this.http.get<AuditTrailDTO[]>(url).toPromise();
    }
}

export interface AuditTrailDTO {
    createdOn: Date | string;
    createdBy: string;
    type: AuditTrailType;
    practiceId: string;
    practiceName: string;
}

export enum AuditTrailType {
    practiceCreated,
    invoiceCreated,
    orderResultCreated,
}
